import { Mail, MailOutlineOutlined } from '@mui/icons-material'
import { Typography } from '@mui/material'
import React from 'react'

export const EmailSent = () => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Typography variant="body-large" marginBottom={"30px"}>Check your email to reset your password</Typography>   
            <MailOutlineOutlined sx={{color: 'green.200', fontSize: '100px'}} />
        </>
    )
}